import { TranslationKey } from "../translations/TranslationKey";

// aka Fachrichtung on the backend
export enum OralExamOption {
  None = "",
  KMU = "KMU",
  Privathaushalte = "Privathaushalte",
}

export const OralExamOptionTranslationKey: { [oralExamOption in OralExamOption]: TranslationKey } = {
  [OralExamOption.None]: "oralExamOption.none",
  [OralExamOption.KMU]: "oralExamOption.kmu",
  [OralExamOption.Privathaushalte]: "oralExamOption.privathaushalte",
};
